<template>
  <div
    class="event-header"
    :class="classObject"
  >
    <img
      v-if="imageSrc"
      :src="imageSrc"
      alt=""
      class="event-header__image"
    >

    <div
      v-if="hasEvent"
      class="event-header__caption"
    >
      <h2
        v-if="large"
        class="event-header__title"
      >
        <span class="event-header__title-background">{{ title }}</span>
      </h2>
      <p
        v-else
        class="event-header__title"
      >
        <span class="event-header__title-background">{{ title }}</span>
      </p>

      <p
        v-if="subtitle"
        class="event-header__subtitle"
      >
        <span class="event-header__title-background">{{ subtitle }}</span>
      </p>

      <p
        v-if="active && tagLeft"
        class="event-header__tag--left tag tag--primary tag--small"
        v-html="tagLeft"
      />
      <p
        v-if="active && tagRight"
        class="event-header__tag--right tag tag--primary tag--small tag--right"
        v-html="tagRight"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CEventHeader',

  props: {
    active: Boolean,
    hasEvent: Boolean,
    large: Boolean,
    image: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    subtitle: {
      type: String,
      default: undefined
    },
    tagLeft: {
      type: String,
      default: undefined
    },
    tagRight: {
      type: String,
      default: undefined
    }
  },

  computed: {
    classObject () {
      return {
        'event-header--active': this.active,
        'event-header--empty': !this.hasEvent,
        'event-header--large': this.large
      }
    },
    imageSrc () {
      return this.image
    }
  }
}
</script>

<i18n locale="en">
{
  "noEventToday": "No event today"
}
</i18n>

<i18n locale="de">
{
  "noEventToday": "Heute keine Veranstaltung"
}
</i18n>

<style lang="scss">
@import "../css/variables";
@import "../css/mixins";

.event-header {
  display: block;
  position: relative;
  z-index: 1; // Push teaser in front of previous and next teasers
  height: 12em;

  text-decoration: none;
  color: #fff;

  background: $color-muted;

  @media (min-width: $breakpoint-md) {
    height: 14em;
  }
}

.event-header--empty {
  display: none;
  background-image: radial-gradient(farthest-corner, #fff, #ddd);

  @media (min-width: $breakpoint-lg) {
    display: block;
  }
}

.event-header__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  object-fit: cover;

  .event-header--empty & {
    top: 1.5em;
    height: 58%;
    object-fit: contain;
  }
}

.event-header__caption {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: $gutter-xs $gutter-sm;

  .event-header--empty & {
    height: auto;
    bottom: 0;
  }
}

.event-header__title,
.event-header__subtitle {
  margin: 0;

  font-weight: 650;
  text-align: center;
  text-transform: uppercase;
}

.event-header__title {
  .event-header--active & {
    font-size: 1.125em;
  }

  @media (min-width: $breakpoint-sm) {
    .event-header--active & {
      font-size: 1.5em;
    }
  }

  @media (min-width: $breakpoint-md) {
    .event-header--large & {
      margin-top: 1em;
    }
  }
}

.event-header__subtitle {
  margin-top: 0.5em;
  font-size: 0.875em;

  @media (min-width: $breakpoint-md) {
    .event-header--active & {
      font-size: 1em;
    }
  }
}

.event-header__title-background {
  padding: 0.25em 0.375em;
  background-color: $color-secondary-dark;
  box-decoration-break: clone;
}

.event-header__tag--left {
  display: block;

  .event-header--large & {
    left: 0;
  }
}

.event-header__tag--right {
  .event-header--large & {
    right: 0;
  }
}

.event-header__info {
  margin-bottom: 0.5em;

  font-size: 0.875em;
  text-align: center;
  text-transform: uppercase;
  color: $color-secondary-dark;

  .event-header--active & {
    margin-bottom: 1em;
    font-size: 1em;
  }
}
</style>
